define('view/controller/booking/datetime/classes/TimeClassesTimeSelectView',['require','view/controller/booking/datetime/slots/TimeSlotsView','view/controller/booking/datetime/classes/TimeClassesTimeItemView','lib/view/UnwrapBehavior'],function (require) {

    var TimeSlotsView = require('view/controller/booking/datetime/slots/TimeSlotsView');
    var TimeClassesTimeItemView = require('view/controller/booking/datetime/classes/TimeClassesTimeItemView');
    var UnwrapBehavior = require('lib/view/UnwrapBehavior');

    /**
     * Slots for classes timeline view (container)
     *
     * @class TimeFlexibleWeeklyView
     */
    return TimeSlotsView.extend({

        template: '#time_classes_time_view',
        childViewContainer: '#time_classes_time_container',
        childView: TimeClassesTimeItemView,
        behaviors: {
            UnwrapBehavior: {
                behaviorClass: UnwrapBehavior
            }
        },

        _bookingModel: null,
        _serviceCollection: null,

        initialize: function () {
            TimeSlotsView.prototype.initialize.apply(this);

            this._serviceCollection = this.getOption('serviceCollection');
            this._bookingModel = this.getOption('bookingModel');

            this.listenTo(this._bookingModel, 'change', this.render);
        },

        serializeData: function () {
            var result = TimeSlotsView.prototype.serializeData.apply(this);

            result.service = this._bookingModel.get('service');
            result.services = this._serviceCollection.toJSON();

            return result;
        }

    });

});
